import React from 'react'

const CardCore = ({card}) => {
  return (
    <div>
        <div className='row pt-4'>
          {card.map((val,i)=>(
            <div key={i} className='col-md-4 text-center mb-4 '>
              <div className=' border-dark border mb-4 rounded-4 overflow-hidden h-100 '>
                <span className='border-bottom d-block bg-light'>
                <img src={val.icon} alt="" className=' icon-logo'/>
                </span>    
                <div className='card-body p-3'>
                <h3 className='fs-5 mb-2 h3-heading '>{val.title}</h3>
                <p className='fs-6 lh-sm h3-para'>{val.desc}</p>
                  </div>            
              </div>
            </div>
          ))}
        </div>
    </div>
  )
}

export default CardCore